import { Injectable, Optional, SkipSelf } from '@angular/core';
import { NotifierMessage, NotifierMessageBase, NotifierMessageType } from './notifier.model';

import { Subject } from 'rxjs/Subject';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class NotifierService {
  private notifierListSubject = new Subject<Array<NotifierMessageBase>>();
  notifierListState = this.notifierListSubject.asObservable();
  notifierMessageList = new Array<NotifierMessageBase>();

  constructor( @Optional() @SkipSelf() prior: NotifierService, private translateService: TranslateService) {
    if (prior) {
      console.log('notifier service already exists');
      return prior;
    }
  }

  close(notifierMessage: NotifierMessageBase) {
    const itemIndex = this.notifierMessageList.indexOf(notifierMessage);
    if (itemIndex >= 0) {
      this.notifierMessageList.splice(itemIndex, 1);
    }
    this.notifierListSubject.next(this.notifierMessageList);
  }

  activateSimple(type: NotifierMessageType, message: string) {
    // Only allow 1 error message at the same time
    if (type === NotifierMessageType.Error) {
      this.notifierMessageList.map(item => this.close(item));
    }

    const notifierMessage = new NotifierMessage();
    notifierMessage.type = type;
    notifierMessage.body = message;
    this.notifierMessageList.push(notifierMessage);
    this.notifierListSubject.next(this.notifierMessageList);
  }


  activateCustom(customMessage: NotifierMessageBase) {
    if (!customMessage) {
      return;
    }
    this.notifierMessageList.push(customMessage);
    this.notifierListSubject.next(this.notifierMessageList);
  }
}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/notifier/notifier.service.ts